import cloneDeep from 'lodash/cloneDeep';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import formatIsoDate from '@/services/general/formatIsoDate';
import getAll from '@/api/echeancierLigneBaf/index';
import genererCritereRechercheCommandeAFacturer
  from '@/services/devisCommandes/genererCritereRechercheCommandeAFacturer';
import * as types from './echeancier-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    echeanciers: [],
    totalEcheanciers: 0,
    echeancier: null,
    criteresRecherche: genererCritereRechercheCommandeAFacturer(false),
    lastDataFromLoad: {},
    orderBy: 'datePrevisionnelleFacturation',
    indicateurAnt: true,
    totalEcheanciersBeforeNow: 0,
    dateSave: {
      dateDebut: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      dateFin: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    },
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ECHEANCIERS](state, echeanciers) {
    state.echeanciers = echeanciers;
  },
  [types.SET_TOTAL_ECHEANCIERS](state, totalEchanciers) {
    state.totalEcheanciers = totalEchanciers;
  },
  [types.SET_ECHEANCIER](state, echeancier) {
    state.echeancier = echeancier;
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
  [types.SET_ORDERBY](state, orderby) {
    state.orderBy = orderby;
  },
  [types.SET_ECHEANCIERS_LASTDATAFROMLOAD](state, lastData) {
    state.lastDataFromLoad = lastData;
  },
  [types.SET_INDICATEUR](state, indicateur) {
    state.indicateurAnt = indicateur;
  },
  [types.SET_TOTAL_ECHEANCIERS_BEFORE_NOW](state, totalEcheanciers) {
    state.totalEcheanciersBeforeNow = totalEcheanciers;
  },
  [types.SET_DATE_SAVE](state, date) {
    state.dateSave = date;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadEcheancier({ commit }, data) {
    if (!data.orderBy) data.orderBy = this.orderBy;
    commit(types.SET_TOTAL_ECHEANCIERS_BEFORE_NOW, initialState().totalEcheanciersBeforeNow);
    commit(types.SET_ECHEANCIERS_LASTDATAFROMLOAD, data);
    const response = await getAll(data);
    response.data.result.items.forEach((echeancier) => {
      echeancier.isDetailOpen = false;
      echeancier.selected = false;
    });
    commit(types.SET_TOTAL_ECHEANCIERS, response.data.result.totalCount);
    commit(types.SET_ECHEANCIERS, response.data.result.items);
    if (data.query.datePrevisionnelleFacturation.dateDebut != null) {
      const newData = cloneDeep(data);
      newData.query.datePrevisionnelleFacturation.dateDebut = null;
      newData.query.datePrevisionnelleFacturation.dateFin = formatIsoDate(new Date());
      getAll(newData).then(responseAnt => {
        commit(types.SET_TOTAL_ECHEANCIERS_BEFORE_NOW, responseAnt.data.result.totalCount);
      });
    } else {
      commit(types.SET_TOTAL_ECHEANCIERS_BEFORE_NOW, response.data.result.totalCount);
    }
    return {};
  },
};

const getters = {
  echeanciers: state => {
    return state.echeanciers;
  },
  totalEcheanciers: state => {
    return state.totalEcheanciers;
  },
  echeancier: state => {
    return state.echeancier;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  orderBy: state => {
    return state.orderBy;
  },
  indicateurAnt: state => {
    return state.indicateurAnt;
  },
  totalEcheanciersBeforeNow: state => {
    return state.totalEcheanciersBeforeNow;
  },
  dateSave: state => {
    return state.dateSave;
  },
  lastDataFromLoad: state => {
    return generalTransformer(state.lastDataFromLoad);
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
